// components/features/support/auditLogs/AuditLogsList.tsx
import { AuditLogEntry } from "../../../../types/features/support/AuditLog";
import TableList from "../../../ui/TableList";
import AuditLogRow from "./AuditLogRow";

interface AuditLogsListProps {
  logs: AuditLogEntry[];
}

export default function AuditLogsList({ logs }: AuditLogsListProps) {
  const columns = [
    { header: "Date / Heure" },
    { header: "Méthode" },
    { header: "Route" },
    { header: "Statut" },
    { header: "Durée" },
    { header: "" },
  ];

  return (
    <TableList
      items={logs}
      columns={columns}
      getId={(log) => log.trace_id}
      selectable={false}
      actionColumn={false}
      emptyMessage="Aucune activité trouvée pour cet utilisateur"
      renderRow={(log) => <AuditLogRow key={log.trace_id} log={log} />}
    />
  );
}
